import QuoteWrapper from "./Components/QuoteWrapper";

function App() {
  return (
      <div className="bg-gray-900 flex flex-col justify-center h-screen w-screen ">
          <QuoteWrapper/>
      </div>
  );
}

export default App;
